import React from "react";
import Page from "./Page";
import QA from "../ui/QA";

const QAPage = () => {
  return (
    <Page
      pageName="qa"
      sx={{ display: "flex", flexDirection: "column" }}
    >
      <QA />
    </Page>
  );
};

export default QAPage;
